import _ from "lodash";
import moment from "moment";
import prettyBytes from "pretty-bytes";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { IonItem } from "@ionic/react";
import { ellipsisHorizontalOutline } from "ionicons/icons";

import { ActionPopover } from "../../../common";

import styled from "styled-components";
const List = styled.div``;
const ListItem = styled(IonItem)``;
const FileDetails = styled.div``;
const FileName = styled.div`
  color: #3880ff;
  font-size: 0.9em;
`;
const FileStatus = styled.div`
  font-size: 0.8em;
  color: #666666;
`;

const FileList = (props) => {
  const filesDisplay = props.files
    .filter((f) => {
      const fileName = _.get(f, "file_name");
      return (
        !props.filter ||
        fileName.toLowerCase().includes(props.filter.toLowerCase())
      );
    })
    .map((f, index) => {
      const fileName = _.get(f, "file_name");
      const fileSize = _.get(f, "file_size");
      const lastModified = moment(_.get(f, "datetime_created")).fromNow();
      const fileUrl = _.get(f, "file");

      const menuOptions = [
        {
          label: "Download File",
          onClick: () => {
            window.open(fileUrl);
          },
        },
      ];

      if (props.uploadAndDeleteEnabled) {
        menuOptions.push({
          label: "Delete File",
          onClick: props.handleDeleteFile,
        });
      }

      return (
        <ActionPopover key={index} menuOptions={menuOptions} actionData={f}>
          <ListItem
            lines="full"
            detail={true}
            detailIcon={ellipsisHorizontalOutline}
          >
            <FileDetails>
              <FileName>{fileName}</FileName>
              <FileStatus>
                {prettyBytes(fileSize)}, modified {lastModified}
              </FileStatus>
            </FileDetails>
          </ListItem>
        </ActionPopover>
      );
    });

  return <List>{filesDisplay}</List>;
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(FileList);
